var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};


site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

site.game = {
	init: function() {
		let notification = MoyaContainer.get('core.notification');
		const options = {
			'duration': 1500,
		};
		var $checkboxes = $('input[type=checkbox]', '.checkboxContainer');
		if (!$checkboxes.length) {
			return false;
		}

		$checkboxes.change(function() {
			if (this.checked) {
				site.game.addImage(this.value);
				notification.success('Mynd bætt við safn', options);
			}
			else {
				notification.info('Mynd tekin úr safni', options);
				site.game.removeImage(this.value);
			}
		});

		$.each(site.game.getImages(), function(index, value) {
			$('input[value="' + value + '"').prop( "checked", true );
		});
	},

	getImages: function() {
		let images = window.localStorage.getItem('images');
		return images ? JSON.parse(images) : [];
	},

	addImage: function(image) {
		let images = site.game.getImages();
		if (images.indexOf(image) === -1) {
			images.push(image);
		}
		window.localStorage.setItem('images', JSON.stringify(images));
	},

	removeImage: function(image) {
		let images = site.game.getImages();
		images = images.filter(function(e) { return e !== image })
		window.localStorage.setItem('images', JSON.stringify(images));

		if ($('.items').hasClass('print')) {
			$('input[value="' + image + '"').closest('.game__item').remove();
		}
	},

	print: function() {
		let $items = $('.category .items');
		$.each(site.game.getImages(), function(index, value) {
			let $item = $('.game__item.hidden').clone();
			$('img', $item).attr('src', $items.data('path') + value);
			$('input', $item).attr('id', 'image-' + index).attr('value', value)
			$('label', $item).attr('for', 'image-' + index);
			$item.removeClass('hidden');
			$items.append($item);
		});
		$('.game__item.hidden').remove();

		$items.sortable({
			update: function( event, ui ) {
				window.localStorage.removeItem('images');
				$('.game__item:not(.hidden)').each(function() {
					let name = $('input', $(this)).attr('value');
					site.game.addImage(name);
				});
			}
		}).disableSelection();

		site.game.init();

		let $removeAll = $('button.removeAll');
		$removeAll.on('click', function() {
			$('.game__item').remove();
			$(this).remove();
			window.localStorage.removeItem('images');
		});

		if ($('.game__item:not(.hidden)').length === 0) {
			$removeAll.remove();
		}

		let perPage = window.localStorage.getItem('perpage');
		if (perPage) {
			$('select#perPage option[value="' + perPage +'"]').attr('selected', true);
		}
		$('select#perPage').change(function () {
			$('.game__items').attr('data-print', this.value);
			window.localStorage.setItem('perpage', this.value);
		}).trigger('change');

		let displayTitle = window.localStorage.getItem('displayTitle');
		if (displayTitle === '1') {
			$('input#displayTitle').attr('checked', true);
		}
		$('input#displayTitle:checkbox').click(function () {
			const isChecked = $(this).is(':checked') ? '1' : '0';
			window.localStorage.setItem('displayTitle', isChecked);
		}).trigger('change');

		$('.btn.pdf').on('click', function() {
			let images = site.game.getImages();
			if (images) {
				let params = {
					images: images.join(','),
					perPage: window.localStorage.getItem('perpage'),
					displayTitle: window.localStorage.getItem('displayTitle')
				};
				let query = $.param( params, true );
				location.href = $('.game__items').attr('data-pdf-url') + '?' + query;
			}
		});
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.game.init();
	//site.svg.init();

	$('#custom-focus .text ul').addClass('owl');
	site.owl.init('.owl', {
		loop:true,
		dots:false,
		nav:true,
		margin:10,
		navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
		responsive:{
			0:{
				items:1
			},
			992:{
				items: 2
			},
			1200:{
				items: 3
			}
		}
	});

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	site.owl.init('.front-album ul', {
		loop: true,
		nav: true,
		dots:false,
		margin:0,
		autoHeight: true,
		startPosition:2,
		center:true,
		navElement:'div',
		navText:["<i class=\"fa fa-angle-left\" />","<i class=\"fa fa-angle-right\" />"],
		items: 1
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
